import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'projects/ppb-shared-library/src/lib/services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class HttpLanguageInterceptorService implements HttpInterceptor {

  constructor(private localStorageService: LocalStorageService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request.clone({
      headers: request.headers.set('Accept-Language', this.localStorageService.getPreferredLanguage())
    }));
  }
}
